import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilityLibService {

  constructor() { }

  getTeste(): string {
    return 'getTeste from utility-lib-service-4.0.0eeeeeeeeeeeeeeee';
  }

  getTeste2(): string {
    return 'getTeste2 from utility-lib-service TESTE222222';
  }
}
